import {createTheme} from '@mui/material/styles';
import {red} from '@mui/material/colors';

const darkTheme = createTheme({
    overrides: {
        MuiFormLabel: {
            asterisk: {
                color: '#db3131',
                '&$error': {
                    color: '#db3131'
                },
                '&$warning': {
                    color: '#db3131'
                },
            }
        },
    },
    // colorMenu: '#fff',
    palette: {
        mode: 'light',
        primary: {
            main: '#1c6e8f',
            contrastText: '#fff',
            gray: {
                main: '#B1B6C0',
                contrastText: '#fff',
            },
            action: {
                main: '#8d6b58',
                contrastText: '#000',
            },
            secondary: {
                main: '#db3131',
                contrastText: '#fff',
            },
            error: {
                main: red.A400,
                contrastText: '#fff',
            },
            background: {
                default: "#181818",
            },
            text: {
                primary: '#fff',
                secondary: '#bdbdbd',
            },
        },
        navButton: { 
            main: '#e8f5fd',
            contrastText: '#ffffff',
        },
    },
    // components: {
    //     MuiButton: {
    //       styleOverrides: {
    //         text: {
    //           color: '#9db1c5', // Override text button color
    //           '&:hover': {
    //             backgroundColor: '#e3f2fd', // light hover effect
    //           },
    //         },
    //       },
    //     },
    //   },
});

export default darkTheme;
